import { createSlice } from "@reduxjs/toolkit";

const activeComponentsSclice = createSlice({
  name: "activeComponentsDetail",
  initialState: {
    categorizedPosDropdown: null,
  },
  reducers: {
    setCategorizedPosDropdown(state, action) {
      state.categorizedPosDropdown = action.payload;
    },
  },
  devTools: true,
});

export const { setCategorizedPosDropdown } = activeComponentsSclice.actions;

export default activeComponentsSclice.reducer;
